<template>
  <div class="summary-mode-root" v-bind:class="{ 'overflow': this.isInGlobalOverflow }">
    <div class="content">
      <div class="icon"></div>
      <div class="report">
        <div class="title">{{deviceStatusTitle}}</div>
        <div class="annotation">{{$t('indicatorLastUpdate', { date: lastUpdateDateText })}}</div>
        <div class="advice" v-if="!this.$isMobile && this.isInGlobalOverflow">
          <div class="icon"></div>
          <div class="text">{{this.indicatorItems.getGlobalShortAdvice()}}</div>
        </div>
        <div class="purifier" v-if="!this.$isMobile && this.hasPurifier">
          <div class="icon" v-bind:style="{ animation: this.purifierIconAnimationStyle }"></div>
          <div class="text">{{$t(this.purifierTextId)}}</div>
        </div>
      </div>
      <div class="advice" v-if="this.$isMobile && this.isInGlobalOverflow">
        <div class="icon"></div>
        <div class="text">{{this.indicatorItems.getGlobalShortAdvice()}}</div>
      </div>
      <div class="purifier" v-if="this.$isMobile && this.hasPurifier">
        <div class="icon" v-bind:style="{ animation: this.purifierIconAnimationStyle }"></div>
        <div class="text">{{$t(this.purifierTextId)}}</div>
      </div>
      <ul class="indicators">
        <li v-for="item in this.indicatorItems" :key="item.data.DataType">
          <SummaryModeIndicatorListItem
            v-bind:indicatorItem="item"
            v-on:click.native="onIndicatorListItemClick(item)"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SummaryModeIndicatorListItem from './SummaryModeIndicatorListItem.vue'
import moment from 'moment'

export default {
  name: 'SummaryMode',
  props: ['contractType', 'indicatorItems', 'hasPurifier', 'purifierFanSpeed'],
  components: { SummaryModeIndicatorListItem },
  data: () => ({
    deviceStatusTitle: null
  }),
  computed: {
    lastUpdateDateText() {
      if (!this.indicatorItems) {
        return '-'
      }
      const d = moment(this.indicatorItems.getLastUpdateDate())
      if (d.isSame(moment(), 'day')) {
        return d.format('LT')
      }
      return d.format('l   LT')
    },
    isInGlobalOverflow() {
      return (
        this.indicatorItems &&
        this.indicatorItems.getGlobalOverflowLevel() !== 'ok'
      )
    },
    purifierTextId() {
      let textId = 'enabledPurifier'
      if (this.hasPurifier && this.purifierFanSpeed) {
        textId = 'runningPurifier'
      }
      return textId
    },
    purifierIconAnimationStyle() {
      let animationStyle = 'none'
      if (this.hasPurifier) {
        if (this.purifierFanSpeed) {
          const cssSpeed = 3 / this.purifierFanSpeed
          animationStyle = `${cssSpeed}s linear infinite infinite-loop`
        }
      }
      return animationStyle
    }
  },
  mounted() {
    this.beforeUpdate()
  },
  beforeUpdate() {
    this.beforeUpdate()
  },
  methods: {
    async beforeUpdate() {
      if (this.contractType && this.indicatorItems) {
        const deviceStatusTitleId =
          this.indicatorItems.getGlobalOverflowLevel() !== 'ok'
            ? 'GlobalStateBad'
            : 'GlobalStateGood'

        this.deviceStatusTitle = await this.$fetch(
          `resource/${deviceStatusTitleId}?contratTypeName=${this.contractType}&language=${this.$languageId}`,
          true // The response is Text and not Json
        )
      }
    },

    onIndicatorListItemClick(item) {
      this.$emit('select-indicator', item)
    }
  }
}
</script>

<style lang="less">
@import '../app.less';

.summary-mode-root {
  padding: 2rem 0;
  background-image: @ok-gradient;
  display: flex;
  flex-direction: column;
  align-items: center;

  &.overflow {
    background-image: @warning-gradient;

    > .content > .icon {
      background-image: url('../assets/status-warning.png');
    }
  }

  > .content {
    color: white;
    display: flex;
    align-items: center;

    .mobile-media({flex-direction: column;});

    > .icon {
      width: 200px;
      height: 200px;
      background-image: url('../assets/status-ok.png');
      background-repeat: no-repeat;
      background-size: cover;
    }

    > .report {
      .mobile-media({order: -1;});
      .desktop-media({max-width: 25rem;});
      margin: 0 1rem;

      > .title {
        .mobile-media({text-align: center;});
        font-size: @biggest-size;
        font-weight: bold;
      }

      > .annotation {
        .mobile-media({text-align: center;});
        margin-top: 0.3rem;
        font-size: @tiny-size;
        opacity: 0.8;
      }
    }

    .advice {
      margin-top: 1rem;
      display: flex;
      align-items: center;

      > .icon {
        width: @icon-size;
        height: @icon-size;
        background: url('../assets/info.png') no-repeat;
        background-size: cover;
      }

      > .text {
        padding-left: 0.5rem;
        font-weight: bold;
        font-size: @bigger-size;
      }
    }

    .purifier {
      margin-top: 1rem;
      display: flex;
      align-items: center;

      > .icon {
        width: @icon-size;
        height: @icon-size;
        background: url('../assets/purifier.png') no-repeat;
        background-size: cover;
      }

      > .text {
        padding-left: 0.5rem;
      }
    }

    > .indicators {
      background-color: white;
      padding: 1.2rem 0.7rem;

      .desktop-media({max-width: 20rem;});

      > li {
        margin: 0.5rem 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SummaryMode.vue